import React from "react";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";
import { Col, Divider, Form, Row, Space } from "antd";

import styles from "./DigitalKeyOwnerDetail.module.css";

function DigitalKeyOwnerDetail({ owner, onChangedOwner }: { owner?: Types.CarOwnerDto; onChangedOwner?: (owner: Types.CarOwnerDto) => void }) {
    const displayInfo = (info: string | undefined) => {
        return info ? info : String.dash;
    };

    return (
        <div>
            <Space direction="vertical" size={10} style={{ width: "100%" }}>
                <Row justify={"space-between"}>
                    <Col span={6}>
                        <Divider className={styles.subTitle} orientation="left">
                            <span>상세보기</span>
                        </Divider>
                    </Col>
                </Row>

                <Form layout="inline">
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="등록일">
                            <span>
                                {owner?.createdDate ? Utils.utcToLocalTime(owner.createdDate.valueOf(), Common.FORMAT_SHORT_DATE_TIME) : String.dash}
                            </span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="차량번호">
                            <span>{displayInfo(owner?.car?.carNumber)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="이름">
                            <span>{displayInfo(owner?.user?.name)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="차량모델">
                            <span>{displayInfo(owner?.car?.carType?.model?.modelName)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="이메일">
                            <span>{displayInfo(owner?.user?.email)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm" label="차량타입">
                            <span>{displayInfo(owner?.car?.carType?.typeName)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm searchLastRow" label="전화번호">
                            <span>{displayInfo(owner?.user?.phone)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                        <Form.Item className="searchForm searchLastRow" label="개폐장치">
                            <span>{displayInfo(owner?.car?.doorModuleImei)}</span>
                        </Form.Item>
                    </Col>
                </Form>
            </Space>
        </div>
    );
}

export default DigitalKeyOwnerDetail;
